import { projectStatusStyle } from "../../utils/constants/projectStatus";

// Full pill, for detail pages where there is room for it.
export const ProjectStatusBadge = ({ status }) => {
  if (!status) return <span className="text-gray-500">—</span>;
  return (
    <span
      className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded ${
        projectStatusStyle(status).badge
      }`}
    >
      {status}
    </span>
  );
};

// Compact dot + label, for tables where a whole status column costs too much
// width. Pair it with statusRail on the row for the colour to read at a glance.
export const ProjectStatusMark = ({ status }) => {
  if (!status) return null;
  const { dot, text } = projectStatusStyle(status);
  return (
    <span className="inline-flex items-center gap-1">
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${dot}`} />
      <span className={`text-[10px] font-medium ${text}`}>{status}</span>
    </span>
  );
};

export const statusRail = (status) => projectStatusStyle(status).rail;
